module.exports = __webpack_public_path__ + "be.no1.094da4f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/be.no1.jpg
// module id = MeDv
// module chunks = 0